import { Modal } from 'antd';
import './index.less';
Modal.config({
    rootPrefixCls: 'oss-ui',
});
export default Modal;
